"use client"

import type { ComponentProps, FunctionComponent } from "react"

import { Pagination as SparkPagination } from "@/modules/layouts/components/Pagination/Pagination"
import { Link } from "@/modules/routing/components/Link"

type PaginationProps = ComponentProps<typeof SparkPagination>

export const Pagination: FunctionComponent<PaginationProps> = ({ ...props }) => {
  return <SparkPagination {...props} linkComponent={Link} />
}
